import { mimSupportedAttachmentTypes } from './mimDraftAttachments';

const mimDraftFailureMessage: Record<string, string> = {
  unsupported_message: `The AI agent can't read one of this conversation's attachments. It only supports ${mimSupportedAttachmentTypes}.`,
  prompt_injection:
    'The AI agent stopped drafting because the conversation looks like a prompt injection attempt.',
  blocked_by_content_policy:
    'The AI agent stopped drafting because the conversation was blocked by its content policy.',
  unable_to_handle:
    "The AI agent couldn't handle this conversation. Try drafting with another AI agent.",
  handoff:
    "The AI agent would hand this conversation over to a human agent, so it didn't draft a reply.",
  handoff_break_containment:
    "The AI agent would hand this conversation over to a human agent, so it didn't draft a reply.",
  handoff_failed: "The AI agent couldn't draft a reply for this conversation.",
  unknown: "The AI agent couldn't draft a reply. Please try again.",
};

/** The message for a failed agent run's exit reason. */
export const getMimDraftFailureMessage = (exitReason?: string | null): string =>
  (exitReason && mimDraftFailureMessage[exitReason.toLowerCase()]) ||
  mimDraftFailureMessage.unknown;

/** The reason shown on a draft action that cannot run yet. */
export const unsupportedAttachmentReason =
  "The AI agent can't read this conversation's attachments";
